module.exports = __webpack_public_path__ + "img/34.63546699.jpg";